import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ReportState } from "./reportSlice.types";
import { cWingsServiceBaseURL } from "../../config/Api.config";
import { EApiMiddlewareMethods } from "../../network/networkHandler.types";
import { addNRPageAction } from "utils/newRelicUtils";
import customNetworHandler from "../../network/customNetworHandler";
import AppConstants from "constants/AppConstants";

export const fetchReportData = createAsyncThunk(
  "Reort/FetchReportData",
  async (payload: any, { rejectWithValue }) => {
    try {
      addNRPageAction(
        AppConstants.NR_FEATURES.REPORTS.NAME,
        AppConstants.NR_FEATURES.REPORTS.FEATURES.FETCH_REPORT
      );
      const request = {
        url: "/fulfilment/v2/export/dashboard",
        method: EApiMiddlewareMethods.POST,
        data: payload,
      } as any;
      const { data } = await customNetworHandler(request, cWingsServiceBaseURL);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const fetchDropDownFilter = createAsyncThunk(
  "Reort/FetchDropDownFilter",
  async (_, { rejectWithValue }) => {
    try {
      const request = {
        url: "/fulfilment/v2/export/dashboard/filters",
        method: EApiMiddlewareMethods.GET,
      } as any;
      const { data } = await customNetworHandler(request, cWingsServiceBaseURL);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const downloadReportData = createAsyncThunk(
  "Reort/DownloadReportData",
  async (id: string, { rejectWithValue }) => {
    try {
      addNRPageAction(
        AppConstants.NR_FEATURES.REPORTS.NAME,
        AppConstants.NR_FEATURES.REPORTS.FEATURES.DOWNLOAD_REPORT
      );
      const request = {
        url: `/fulfilment/v2/export/download?id=${id}`,
        method: EApiMiddlewareMethods.GET,
      } as any;
      const { data } = await customNetworHandler(request, cWingsServiceBaseURL);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const resetData = createAsyncThunk("Reort/resetData", () => {
  return false;
});

const initialState: ReportState = {
  loading: false,
  error: "",
  reportdata: { elements: [], pageNumber: 0, totalElements: 0, totalPages: 0 },
  tableLoading: false,
  dropDownFilters: [],
  downloadLink: "",
};

const ReportSlice = createSlice({
  name: "Users",
  initialState,
  reducers: {},
  extraReducers: (builders) => {
    builders
      .addCase(fetchDropDownFilter.pending, (state) => {
        state.loading = true;
        state.error = "";
        state.tableLoading = true;
      })
      .addCase(fetchDropDownFilter.fulfilled, (state, action) => {
        state.loading = false;
        state.tableLoading = false;

        state.dropDownFilters = action.payload.results;
      })
      .addCase(fetchDropDownFilter.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(downloadReportData.pending, (state) => {
        state.loading = true;
        state.error = "";
        state.tableLoading = true;
      })
      .addCase(downloadReportData.fulfilled, (state, action) => {
        state.loading = false;
        state.tableLoading = false;
        state.downloadLink = action.payload.results;
      })
      .addCase(downloadReportData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchReportData.pending, (state) => {
        state.loading = true;
        state.error = "";
        state.tableLoading = true;
      })
      .addCase(fetchReportData.fulfilled, (state, action) => {
        state.loading = false;
        state.tableLoading = false;
        const {
          payload,
          meta: {
              arg: {
                pageNumber
                }
          }
      } = action;
      state.reportdata = {
        ...payload,
        elements:
          pageNumber === 0
            ? (payload && payload.results && Array.isArray(payload.results.elements) ? [...payload.results.elements] : [])
            : [
                ...(Array.isArray(state?.reportdata?.elements) ? state.reportdata.elements : []),
                ...(payload && payload.results && Array.isArray(payload.results.elements) ? payload.results.elements : [])
              ],
        pageNumber: payload?.results?.pageNumber,
        totalElements: payload?.results?.totalElements,
        totalPages: payload?.results?.totalPages
      };
      })
      .addCase(fetchReportData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(resetData.fulfilled, (state, action) => {
        state.reportdata = {
          elements: [],
          pageNumber: 0,
          totalElements: 0,
          totalPages: 0,
        };
        state.dropDownFilters = [];
      });
  },
});

export default ReportSlice.reducer;
